import React, {useContext, useEffect, useState} from "react";
import { CardMedia, Drawer, List, Stack } from "@mui/material";
import { Link } from "react-router-dom";
import { defaultLogoUrls, sidebarLogoUrls, ThemeModeContext } from "../shared/Theme.jsx";
import companyService from "../services/companyService.js";
import SidebarMenuItem from "./Sidebar/SidebarMenuItem.jsx";

const Sidebar = () => {
	
	const themeModeContext = useContext(ThemeModeContext);
	
	let [ defaultLogo, setDefaultLogo ] = useState(defaultLogoUrls[themeModeContext.themeMode]);
	let [ sidebarLogo, setSidebarLogo ] = useState(sidebarLogoUrls[themeModeContext.themeMode]);
	let [ companyLogo, setCompanyLogo ] = useState(companyService.selectedCompany.logo);
	
	const sideBarStyle = {
		width: 280,
		flexShrink: 0,
		"& .MuiDrawer-paper": {
			width: 280,
			boxSizing: "border-box",
			bgcolor: "background.sidebar",
			color: "text.primary",
			padding: "10px",
			border: "0"
		},
		overflow: "visible !important"
	};
	
	useEffect(() => {
		companyService.onSelectCompany(() => {
			if (companyService.selectedCompany.logo) {
				setCompanyLogo(companyService.selectedCompany.logo);
			}
			else {
				setCompanyLogo(null);
			}
		});
	}, []);
	
	useEffect(() => {
		setDefaultLogo(defaultLogoUrls[themeModeContext.themeMode]);
		setSidebarLogo(sidebarLogoUrls[themeModeContext.themeMode]);
	}, [ themeModeContext ]);
	
	return (
		<Drawer
			sx={sideBarStyle}
			variant="permanent"
			anchor="left"
			PaperProps={{sx:{overflowY: "visible"}}}
		>
			<Stack direction="column" sx={{ height: "100%" }}>
				<Link to="/">
					{(companyLogo)?
						<CardMedia
							component='img'
							src={companyLogo}
							alt="company logo" 
							sx={{ width: "219px", marginLeft: "2em" }}
						/>
						:
						<CardMedia
							component='img'
							src={defaultLogo}
							alt="company logo" 
							sx={{ width: "219px", marginLeft: "2em" }}
						/>
					}
				</Link>
				<List>
					<SidebarMenuItem path="/" alternatepath="" label="Home"/>
					<SidebarMenuItem path="/risk" alternatepath="/rags" label="Cyber Risk"/>
					<SidebarMenuItem path="/darkweb" alternatepath="" label="Dark Web"/>
					<SidebarMenuItem path="/pentest" alternatepath="" label="Penetration Testing"/>
					<SidebarMenuItem path="/training" alternatepath="" label="People & Process"/>
					<SidebarMenuItem path="/insurance" alternatepath="" label="Cyber Insurance"/>
					<SidebarMenuItem path="/report" alternatepath="" label="Report Generator"/>
				</List>
			</Stack>
			<CardMedia
				component='img'
				src={sidebarLogo}
				alt="company logo" 
				sx={{ width: "60px", position: "relative", bottom: "2em", marginLeft: "8em" }}
			/>
		</Drawer>
	);
}

export default Sidebar;
